import { render, staticRenderFns } from "./add.vue?vue&type=template&id=5de3ed84&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=5de3ed84&prod&scoped=true&lang=css"
import style1 from "./add.vue?vue&type=style&index=1&id=5de3ed84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de3ed84",
  null
  
)

export default component.exports